export default __webpack_public_path__ + "static/socar-d44b7a81efeba71cefca0f6964c75ae2.svg";